import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=6798d8e3&scoped=true&"
import script from "./Invitation.vue?vue&type=script&lang=js&"
export * from "./Invitation.vue?vue&type=script&lang=js&"
import style0 from "./Invitation.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Invitation.vue?vue&type=style&index=1&id=6798d8e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798d8e3",
  null
  
)

component.options.__file = "Invitation.vue"
export default component.exports